import { render, staticRenderFns } from "./FieldCentro.vue?vue&type=template&id=e565774c"
import script from "./FieldCentro.vue?vue&type=script&lang=js"
export * from "./FieldCentro.vue?vue&type=script&lang=js"
import style0 from "./FieldCentro.vue?vue&type=style&index=0&id=e565774c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports